import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const baseModalCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}dialog{border:none;margin:0;padding:0;max-width:100%;max-height:100%;background:transparent}dialog::backdrop{background-color:rgba(0, 0, 0, 0.5);overflow:hidden}dialog:not([open]){display:none}";
const BaseModalStyle0 = baseModalCss;

const BiModal = /*@__PURE__*/ proxyCustomElement(class BiModal extends H {
    constructor() {
        super();
        this.__registerHost();
        this.close = createEvent(this, "close", 7);
        /**
         * If true, clicking on the backdrop will not close the modal.
         */
        this.disableBackdropClick = false;
        /** If true, the modal is open. */
        this.isOpen = false;
        this.lastFocusedElement = null;
        this.onKeyDown = (event) => {
            if (event.key === 'Escape') {
                event.stopPropagation();
                this.handleClose();
            }
        };
    }
    watchPropHandler(newValue) {
        if (newValue) {
            this.handleOpen();
        }
        else {
            this.handleClose();
        }
    }
    async handleClose() {
        document.body.style.overflow = '';
        this.isOpen = false;
        this.dialogElement.close();
        this.lastFocusedElement?.focus();
        this.close.emit();
    }
    async handleOpen() {
        this.lastFocusedElement = document.activeElement;
        this.dialogElement.showModal();
        document.body.style.overflow = 'hidden';
    }
    componentDidLoad() {
        if (this.isOpen) {
            this.handleOpen();
        }
    }
    render() {
        return (h(Host, { key: '3105209aa52eecb41a035a65c989934c8b3d66bf' }, h("dialog", { key: 'd69f7e57d726f0e781f0ba942220bd86f517d3d3', onKeyDown: this.onKeyDown, ref: (el) => (this.dialogElement = el), class: classNames(this.classes), onClick: (event) => {
                if (this.disableBackdropClick)
                    return;
                if (event.target === this.dialogElement) {
                    this.handleClose();
                }
            } }, h("slot", { key: '602c443254551a47c5a7c082f9362ab248ee2e8f' }))));
    }
    static get watchers() { return {
        "isOpen": ["watchPropHandler"]
    }; }
    static get style() { return BaseModalStyle0; }
}, [4, "base-modal", {
        "disableBackdropClick": [516, "disable-backdrop-click"],
        "classes": [1],
        "isOpen": [1540, "is-open"],
        "handleClose": [64],
        "handleOpen": [64]
    }, undefined, {
        "isOpen": ["watchPropHandler"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["base-modal"];
    components.forEach(tagName => { switch (tagName) {
        case "base-modal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiModal);
            }
            break;
    } });
}

export { BiModal as B, defineCustomElement as d };
